import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { NiptResult } from '../interfaces/nipt-result.interface';
import { RefResponse } from '../interfaces/ref-response.interface';

@Injectable({
  providedIn: 'root',
})
export class NiptApiService {
  errorDisplayed = false;
  constructor(private http: HttpClient) {}

  public getRefData(ref: string): Observable<RefResponse> {
    return this.http
      .get<RefResponse>(`/api/nipt-online/references/${ref}`)
      .pipe(
        shareReplay({
          bufferSize: 1,
          refCount: true,
        })
      );
  }

  public getResults(): Observable<NiptResult[]> {
    return this.http.get<NiptResult[]>('/api/nipt-online/results');
  }

  public getResult(testId: string): Observable<NiptResult> {
    return this.http.get<NiptResult>(`/api/nipt-online/results/${testId}`);
  }

  public isClaimed(kitId: string): Observable<boolean> {
    return this.http
      .get(`/api/nipt-online/link-check/${kitId}`)
      .pipe(map((response: any) => !!response.linked));
  }

  /**
   * Claim kit
   * Should return 200 if successful or 400 if kit is already claimed / email doesn't match.
   *
   * To "unlink" (for testing purpose) use API: POST https://api-stg.geneplanet.com/api/nipts/NiptTest/{testId}/tell/UnlinkUserAccountFromNiptTest
   *
   * @param testId Test ID
   * @param barcode Known as kitId as well
   */
  public claimKit(testId: string, barcode: string): Observable<any> {
    return this.http.put(`/api/nipt-online/${testId}/claim`, { barcode });
  }
}
